import { render, staticRenderFns } from "./PlanSuperScoreWidget.vue?vue&type=template&id=89df16c6&scoped=true"
import script from "./PlanSuperScoreWidget.vue?vue&type=script&lang=ts"
export * from "./PlanSuperScoreWidget.vue?vue&type=script&lang=ts"
import style0 from "./PlanSuperScoreWidget.vue?vue&type=style&index=0&id=89df16c6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89df16c6",
  null
  
)

export default component.exports